(function(){
'use strict';
if(window.__elcExpressV2MapsLoaded)return;
window.__elcExpressV2MapsLoaded=true;

var input=document.querySelector('[data-express-v2-search]');
var mapEl=document.querySelector('[data-express-v2-map]');
var configEl=document.getElementById('express-delivery-v2-config');
if(!input||!mapEl||!configEl)return;

var mapsKey='';
try{mapsKey=String(JSON.parse(configEl.textContent||'{}').mapsBrowserKey||'').trim();}
catch(error){console.error('Express Delivery: map config invalid',error);}
var map=null,marker=null,autocomplete=null,loading=false,initialized=false;
var lastSelection=null;
var baseCenter={lat:25.163,lng:55.27};
var selectionVersion=0;
var reverseRequest=null;
var STORAGE='elc_express_v2_location';

function notice(message,isError){
  var el=document.querySelector('[data-express-v2-status]');
  if(!el)return;
  el.textContent=message||'';
  el.dataset.tone=isError?'error':'';
}
function validLocation(loc){
  return loc&&Number.isFinite(Number(loc.lat))&&Number.isFinite(Number(loc.lng))&&
    Number(loc.lat)>=-90&&Number(loc.lat)<=90&&Number(loc.lng)>=-180&&Number(loc.lng)<=180;
}
function putPin(loc,center){
  if(!initialized||!validLocation(loc))return;
  var at={lat:Number(loc.lat),lng:Number(loc.lng)};
  if(!marker){
    marker=new google.maps.Marker({map:map,position:at,draggable:true,title:'Your delivery pin'});
    marker.addListener('dragend',function(evt){choosePin(evt.latLng.lat(),evt.latLng.lng(),'Pinned map location','map');});
  }else{
    marker.setPosition(at);marker.setVisible(true);
  }
  if(center){map.panTo(at);map.setZoom(15);}
}
function areaFromResults(results){
  var entries=Array.isArray(results)?results:[];
  var typePriority=['neighborhood','sublocality_level_1','sublocality_level_2','sublocality','administrative_area_level_3','locality'];
  var city='';
  for(var i=0;i<entries.length;i+=1){
    var components=entries[i].address_components||[];
    for(var j=0;j<components.length;j+=1){
      var component=components[j];
      if(!city&&component.types&&component.types.some(function(type){return type==='locality'||type==='administrative_area_level_1';})){
        city=String(component.long_name||'').trim();
      }
    }
  }
  for(var k=0;k<typePriority.length;k+=1){
    for(var r=0;r<entries.length;r+=1){
      var parts=entries[r].address_components||[];
      for(var p=0;p<parts.length;p+=1){
        var item=parts[p];
        var name=String(item.long_name||'').trim();
        if(!name||!Array.isArray(item.types)||item.types.indexOf(typePriority[k])<0)continue;
        if(name==='United Arab Emirates'||name==='UAE')continue;
        if(city&&name.toLowerCase()!==city.toLowerCase()&&name.toLowerCase().indexOf(city.toLowerCase())<0){
          return name+' - '+city;
        }
        return name;
      }
    }
  }
  var formatted=entries[0]&&String(entries[0].formatted_address||'').trim();
  return formatted||'';
}
function isGenericArea(location){
  if(!location||location.area)return false;
  return /^(current location|finding your area|pinned map location|pinned location)/i.test(String(location.label||''));
}
function sameCoordinates(a,b){
  return validLocation(a)&&validLocation(b)&&Math.abs(Number(a.lat)-Number(b.lat))<0.000001&&
    Math.abs(Number(a.lng)-Number(b.lng))<0.000001;
}
function gpsFallback(location){
  return {
    lat:Number(location.lat),lng:Number(location.lng),
    label:'GPS pin ('+Number(location.lat).toFixed(4)+', '+Number(location.lng).toFixed(4)+')',
    area:'GPS pin - area unavailable',source:'gps'
  };
}
function completeAreaLookup(request,results,ok){
  if(reverseRequest!==request)return;
  reverseRequest=null;
  var result=ok&&results&&results[0]||null;
  var area=ok?areaFromResults(results):'';
  var selected=area?{
    lat:Number(request.location.lat),lng:Number(request.location.lng),
    label:String(result&&result.formatted_address||request.location.label||area).trim(),
    area:area,source:request.location.source||'gps'
  }:gpsFallback(request.location);
  if(request.saved){
    var saved=null;
    try{saved=JSON.parse(sessionStorage.getItem(STORAGE)||'null');}catch(_e){}
    if(!sameCoordinates(saved,request.location)||saved&&saved.area)return;
    var replacement=Object.assign({},saved,{
      area:selected.area,
      label:isGenericArea(saved)?selected.label:saved.label
    });
    if(request.location.source!=='gps'&&!area){
      replacement.area='';
      replacement.label=saved.label;
    }
    sessionStorage.setItem(STORAGE,JSON.stringify(replacement));
    window.dispatchEvent(new CustomEvent('express-delivery:location-updated',{detail:replacement}));
    if(sameCoordinates(lastSelection,saved)&&!lastSelection.area&&document.querySelector('[data-express-v2-overlay]:not([hidden])')){
      lastSelection=Object.assign({},lastSelection,{label:replacement.label,area:replacement.area});
      document.dispatchEvent(new CustomEvent('express-v2:coordinate-selected',{detail:lastSelection}));
    }
  }else{
    lastSelection=selected;
    input.value=selected.label;
    putPin(selected,true);
    document.dispatchEvent(new CustomEvent('express-v2:coordinate-selected',{detail:selected}));
    if(!area)notice('Your GPS pin is saved, but the area name could not be found. Confirm the pin or search an address.',true);
    else notice('Delivery area identified: '+area);
  }
}
function runAreaLookup(){
  var request=reverseRequest;
  if(!request||request.started)return;
  if(!window.google||!google.maps||!google.maps.Geocoder)return;
  request.started=true;
  try{
    new google.maps.Geocoder().geocode({location:{
      lat:Number(request.location.lat),lng:Number(request.location.lng)
    }},function(results,state){
      completeAreaLookup(request,results,state==='OK'&&!!(results&&results.length));
    });
  }catch(_e){
    completeAreaLookup(request,[],false);
  }
}
function queueAreaLookup(location,saved){
  if(!validLocation(location))return;
  if(reverseRequest&&sameCoordinates(reverseRequest.location,location))return;
  selectionVersion+=1;
  var request={location:location,saved:!!saved,version:selectionVersion,started:false};
  reverseRequest=request;
  window.setTimeout(function(){if(reverseRequest===request)completeAreaLookup(request,[],false);},18000);
  if(initialized){runAreaLookup();return;}
  load();
}
function resolveOldSavedLocation(){
  var saved=null;
  try{saved=JSON.parse(sessionStorage.getItem(STORAGE)||'null');}catch(_e){}
  if(validLocation(saved)&&!saved.area&&['gps','map','search'].indexOf(saved.source)>=0){
    queueAreaLookup(saved,true);
  }
}
function choosePin(lat,lng,label,source,area){
  if(!Number.isFinite(lat)||!Number.isFinite(lng))return;
  if(lat<22.0||lat>27.0||lng<51.0||lng>57.0){
    notice('Please choose a location within the UAE.',true);
    return;
  }
  selectionVersion+=1;
  reverseRequest=null;
  lastSelection={lat:lat,lng:lng,label:label,area:String(area||'').trim(),source:source};
  if(source!=='map')input.value=label;
  putPin(lastSelection,true);
  document.dispatchEvent(new CustomEvent('express-v2:coordinate-selected',{detail:lastSelection}));
  if(source==='map'){
    input.value='Pinned location';
    if(window.google&&google.maps&&google.maps.Geocoder){
      var version=selectionVersion;
      new google.maps.Geocoder().geocode({location:{lat:lat,lng:lng}},function(results,state){
        if(version!==selectionVersion)return;
        if(state==='OK'&&results&&results[0]){
          input.value=results[0].formatted_address;
          var selected={lat:lat,lng:lng,label:results[0].formatted_address,area:areaFromResults(results),source:'map'};
          lastSelection=selected;
          document.dispatchEvent(new CustomEvent('express-v2:coordinate-selected',{detail:selected}));
        }
      });
    }
  }
}
function initialize(){
  if(initialized)return;
  if(!window.google||!google.maps||!google.maps.places||!google.maps.places.Autocomplete){
    notice('Address search is unavailable. Please use your current location.',true);
    input.disabled=true;
    return;
  }
  loading=false;
  initialized=true;
  input.disabled=false;
  mapEl.hidden=false;
  map=new google.maps.Map(mapEl,{
    center:baseCenter,zoom:11,fullscreenControl:false,streetViewControl:false,
    mapTypeControl:false,gestureHandling:'cooperative',
    restriction:{latLngBounds:{north:26.65,south:22.55,east:56.7,west:51.45},strictBounds:false}
  });
  autocomplete=new google.maps.places.Autocomplete(input,{
    componentRestrictions:{country:'ae'},
    fields:['geometry','formatted_address','name','address_components']
  });
  autocomplete.addListener('place_changed',function(){
    var place=autocomplete.getPlace();
    if(!place||!place.geometry||!place.geometry.location){
      notice('Select a location from the address suggestions.',true);
      return;
    }
    var placeLabel=place.formatted_address||place.name||input.value;
    choosePin(place.geometry.location.lat(),place.geometry.location.lng(),placeLabel,'search',areaFromResults([place]));
  });
  map.addListener('click',function(event){
    choosePin(event.latLng.lat(),event.latLng.lng(),'Pinned map location','map');
  });
  if(validLocation(lastSelection))putPin(lastSelection,true);
  notice('Search an address or move the pin to your exact delivery location.');
  if(reverseRequest)runAreaLookup();
}
function load(){
  if(initialized){
    if(validLocation(lastSelection))putPin(lastSelection,true);
    if(map&&window.google&&google.maps&&google.maps.event)google.maps.event.trigger(map,'resize');
    return;
  }
  if(window.google&&google.maps&&google.maps.places){
    initialize();
    return;
  }
  if(loading)return;
  if(!mapsKey){
    input.disabled=true;
    notice('Address search is not configured. You can still use your current location.',true);
    if(reverseRequest)completeAreaLookup(reverseRequest,[],false);
    return;
  }
  loading=true;
  input.disabled=true;
  notice('Loading address search...');
  window.__elcExpressV2GoogleMapsReady=function(){initialize();};
  var existing=document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
  if(existing){
    existing.addEventListener('load',function(){initialize();},{once:true});
    if(window.google&&google.maps&&google.maps.places)initialize();
    return;
  }
  var script=document.createElement('script');
  script.async=true;
  script.src='https://maps.googleapis.com/maps/api/js?key='+encodeURIComponent(mapsKey)+
    '&libraries=places&region=AE&language=en&loading=async&callback=__elcExpressV2GoogleMapsReady';
  script.onerror=function(){
    loading=false;
    input.disabled=true;
    notice('Address search could not load. Please use your current location.',true);
    if(reverseRequest)completeAreaLookup(reverseRequest,[],false);
  };
  document.head.appendChild(script);
}

input.addEventListener('input',function(){
  selectionVersion+=1;
  reverseRequest=null;
  lastSelection=null;
  document.dispatchEvent(new CustomEvent('express-v2:search-cleared'));
});
document.addEventListener('express-v2:opened',function(event){
  var saved=event.detail&&event.detail.location;
  lastSelection=validLocation(saved)?saved:null;
  input.value=lastSelection?lastSelection.label:'';
  load();
});
document.addEventListener('express-v2:pending-changed',function(event){
  var loc=event.detail;
  if(validLocation(loc)){
    lastSelection=loc;
    input.value=loc.label||'';
    putPin(loc,true);
    if(loc.source==='gps'&&isGenericArea(loc))queueAreaLookup(loc,false);
  }else{
    lastSelection=null;
    if(marker)marker.setVisible(false);
  }
});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',resolveOldSavedLocation,{once:true});
else resolveOldSavedLocation();
})();